import { render, staticRenderFns } from "./bind-wechat-dialog.vue?vue&type=template&id=4f08496e&"
import script from "./bind-wechat-dialog.vue?vue&type=script&lang=js&"
export * from "./bind-wechat-dialog.vue?vue&type=script&lang=js&"
import style0 from "./bind-wechat-dialog.vue?vue&type=style&index=0&id=4f08496e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports